export const PaywallMeterModalClassName = "offer-meter-open";
